module.exports = "/assets/data/5798dc3b2d1abfb888e6934e418b7f7f-CA4.data.json";